/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
/* eslint-disable no-dupe-keys */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import axios from 'axios';
import {
  Forgot,
  Navbar,
  Footer,
  Sidebar,
  ThemeSettings,
  BasicTabs,
  FlipOrig,
  ResetPassword,
  Recordings,
  OTA,
  Jobs,
  AssociateSchedule,
  Events,
  HTMLFiles,
  OrgChart,
} from './components';
import Home from './pages/home';
import AutoLogoutHandler from './components/AutoLogoutHandler';

import Login from './pages/login';

import {
  Organizations,
  Alerts,
  Risks,
  Analytics,
  Onboarding,
  Calendar,
  Campaign,
  Associates,
  Associate,
  Triage,
  AssociatePage,
  AssociateLayout,
  MobileAssociateLayout,
  Calliope,
  AssociatesControlCenter,
  AssociatesDashboard,
  InventoryControlCenter,
  ManagerControlCenter,
  MobileManager,
  NotFound,
  Stats,
  Inventory,
  Inventory2,
  InventoryPage,
  Inv,
  Users,
  Managers,
  Manager,
  Reports,
  NotificationEvents,
  Roles,
  Templates,
} from './pages';

import './App.css';
import { useStateContext } from './contexts/ContextProvider';

const App = () => {
  const {
    setCurrentColor,
    setCurrentMode,
    currentMode,
    activeMenu,
    themeSettings,
    loggedIn,
    setLoggedIn,
    isMobile,
  } = useStateContext();
  const [tokenRefresh, setTokenRefresh] = useState(new Date());
  const [zackat, setZackat] = useState(true);
  const [email, setEmail] = useState('');
  // let lastActivity = 0;
  const { REACT_APP_API_ENDPOINT } = process.env;
  const lusr = localStorage.getItem('user');
  let usr = null;
  if (lusr) {
    usr = JSON.parse(lusr);
  }
  useEffect(() => {
    const currentThemeColor = localStorage.getItem('colorMode');
    const currentThemeMode = localStorage.getItem('themeMode');
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    } else {
      setCurrentColor('#1F7738'); /* #1F7738 */
      setCurrentMode('Light');
    }
  }, []);

  useEffect(() => {
    // Fetch the user email and token from local storage
    // const user = JSON.parse(localStorage.getItem('user'));
    // If the token/email does not exist, mark the user as logged out
    if (!usr || !usr.token) {
      setLoggedIn(false);
      return;
    }
    // If the token exists, verify it with the auth server to see if it is valid
    fetch(`${REACT_APP_API_ENDPOINT}/verify`, {
      method: 'POST',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: usr.email,
        token: usr.token,
        _id: usr._id,
        organizationid: usr.organizationid,
      }),
    })
      .then((r) => r.json())
      .then((r) => {
        setLoggedIn(r.message === 'success');
        localStorage.setItem('user', JSON.stringify({
          _id: r._id,
          loggedIn: (r.message === 'success'),
          message: r.message,
          email: r.email,
          token: r.token,
          organizationid: r.organizationid,
        }));
        setEmail(usr.email || '');
      })
      .catch(() => {
        localStorage.removeItem('organization');
        localStorage.removeItem('user');
        window.location.reload();
      });
  }, [tokenRefresh]);
  //  const INTERVAL_TIME = 1000 * 60 * 60 * 10;
  /*
  const INTERVAL_TIME = 1000 * 60 * 15;
  const REFRESH_TIME = 1000 * 60 * 30;
  const timerid = React.useRef();

  useEffect(() => {
    if (!timerid.current) {
      timerid.current = setInterval(() => { setTokenRefresh(new Date()); }, REFRESH_TIME);
    }
    return () => {
      timerid.current = clearInterval(timerid.current);
    };
  }, []);
  const events = [
    'mousedown',
    'mousemove',
    'wheel',
    'keydown',
    'touchstart',
    'scroll',
    // ... add other events here ...
  ];

  const addListeners = (eevents, cb) => {
    const loc = window.location;
    if (loc.pathname !== '/') {
      eevents.forEach((event) => window.addEventListener(event, cb, { passive: true }));
    }
    return () => {
      events.forEach((event) => window.removeEventListener(event, cb, { passive: true }));
    };
  };
*/
  const [tabNo, setTabNo] = useState(0);
  /*
  const useRefreshTokenInterval = (activeAccount, interval = INTERVAL_TIME) => {
    const intervalRef = React.useRef();
    const unlistenRef = React.useRef();
    const wasActiveRef = React.useRef(false);

    React.useEffect(() => {
      const refreshTokenInterval = (initial) => {
        if (!initial && !wasActiveRef.current) {
          // Inactive, clearing interval, not refreshing token
          // CookieService.remove(activeAccount);
          localStorage.removeItem('user');
          localStorage.removeItem('activeMenu');
          if (unlistenRef.current) {
            unlistenRef.current();
          }
          intervalRef.current = clearInterval(intervalRef.current);
          window.location.assign('/');
          console.log('Automatic logout');
        }
        try {
          const isLoggedIn = loggedIn;
          if (isLoggedIn) {
            // Attempting token refresh
            // AuthenticationService.refresh(null, (response) =>
            //  CookieService.set(activeAccount, response.data)
            // );
          }
        } catch (error) {
          alert(error);
        } finally {
          // Reset activity for next interval
          lastActivity += 1;
          let minutes = 10;
          if (usr && usr.loggedIn && usr.email === 'rhenke@zackat.com') {
            minutes *= 100;
          }
          if (lastActivity >= minutes) {
            wasActiveRef.current = false;
          }
        }
      };

      const loc = window.location;
      if (loc.pathname !== '/') {
        refreshTokenInterval(true); // <-- initial call

        // Setup token refresh interval
        intervalRef.current = setInterval(refreshTokenInterval, interval);
        // Add activity event listeners
        unlistenRef.current = addListeners(events, () => {
        // There was some activity
          lastActivity = 0;
          wasActiveRef.current = true;
        });
      }

      // Return cleanup function to clear any running interval timer
      // and unsubscribes event listeners
      return () => {
        clearInterval(intervalRef.current);
        if (unlistenRef.current) {
          unlistenRef.current();
        }
      };
    }, [activeAccount, interval]);
  };
  useRefreshTokenInterval('');
  */
  const blank = '';
  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <div className="flex relative dark:bg-main-dark-bg">
          {loggedIn && activeMenu ? (
            <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
              {loggedIn ? (<Sidebar />) : (<div>{blank}</div>)}
            </div>
          ) : (
            <div className="w-0 dark:bg-secondary-dark-bg">
              {loggedIn ? (<Sidebar />) : (<div>{blank}</div>)}
            </div>
          )}
          <div
            className={
              activeMenu
                ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-72 w-full  '
                : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen w-full'
            }
          >
            <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
              {loggedIn && <Navbar />}
            </div>
            <div>
              {themeSettings && (<ThemeSettings />)}
              <AutoLogoutHandler>
                <Routes>
                  {/* dashboard  */}
                  <Route path="*" element={<NotFound />} />

                  <Route
                    path="/"
                    element={<Home email={email} loggedIn={loggedIn} setLoggedIn={setLoggedIn} />}
                  />
                  <Route path="/login" element={<Login setLoggedIn={setLoggedIn} setEmail={setEmail} />} />
                  {/* pages  */}
                  <Route path="/organizations" element={<Organizations />} />
                  <Route path="/alerts" element={<Alerts />} />
                  <Route path="/risks" element={<Risks />} />
                  <Route path="/dashboard" element={<Analytics />} />
                  <Route path="/onboarding" element={<Onboarding />} />
                  <Route path="/associatesv0" element={<Associates />} />
                  <Route path="/associates" element={<Associate />} />
                  <Route path="/associatestriage" element={<Triage />} />
                  <Route path="/associatepage" element={<AssociatePage />} />
                  {!isMobile && <Route path="/associatelayout" element={<AssociateLayout />} />}
                  {isMobile && <Route path="/associatelayout" element={<MobileAssociateLayout />} />}
                  <Route path="/mobilelayout" element={<MobileAssociateLayout />} />
                  <Route path="/associatescontrolcenter" element={<AssociatesControlCenter />} />
                  <Route path="/associatesdashboard" element={<AssociatesDashboard />} />
                  <Route path="/inventorycontrolcenter" element={<InventoryControlCenter />} />
                  {!isMobile && <Route path="/managercontrolcenter" element={<ManagerControlCenter />} />}
                  {isMobile && <Route path="/managercontrolcenter" element={<MobileManager />} />}
                  <Route path="/users" element={<Users />} />
                  <Route path="/managers" element={<Managers />} />
                  <Route path="/manager" element={<Manager />} />
                  <Route path="/roles" element={<Roles />} />
                  <Route path="/templates" element={<Templates />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/notificationevents" element={<NotificationEvents />} />
                  <Route path="/basic" element={<BasicTabs tabNo={tabNo} />} />
                  <Route path="/cardflip" element={<FlipOrig />} />

                  <Route path="/reports" element={<Reports />} />
                  <Route path="/inventoryv0" element={<Inv />} />
                  <Route path="/inventorypage" element={<InventoryPage />} />
                  <Route path="/card" element={<Inventory />} />
                  <Route path="/inventory" element={<Inventory2 />} />
                  <Route path="/forgot" element={<Forgot />} />
                  <Route exact path="/resetPassword" element={<ResetPassword />} />
                  <Route path="/calendar" element={<Calendar />} />
                  <Route path="/campaign" element={<Campaign />} />
                  <Route path="/recordings" element={<Recordings />} />
                  <Route path="/ota" element={<OTA />} />
                  <Route path="/jobs" element={<Jobs />} />
                  <Route path="/associateschedule" element={<AssociateSchedule />} />
                  <Route path="/calliope" element={<Calliope />} />
                  <Route path="/hipaa" element={<HTMLFiles props={{ mdfile: 'hipaa.md' }} />} />
                  <Route path="/privacy" element={<HTMLFiles props={{ mdfile: 'privacy.md' }} />} />
                  <Route path="/tos" element={<HTMLFiles props={{ mdfile: 'tos.md' }} />} />
                  <Route path="/orgchart" element={<OrgChart />} />
                  <Route path="/stats" element={<Stats />} />
                </Routes>
              </AutoLogoutHandler>
            </div>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
};

export default App;
